<mat-tab-group class="tab-group-content">
  <mat-tab label="CADASTRO">
    <form [formGroup]="formCompanyRegistration" (ngSubmit)="submitCompanyData()">
      <div class="header-company">
        <h1>Dados Cadastrais:</h1>

        <mat-checkbox [checked]="!formCompanyRegistration.value.isActive" (change)="formCompanyRegistration.get('isActive').setValue(!$event.checked)"
          >Inativar empresa</mat-checkbox
        >
      </div>
      <div fxFlex="100">
        <mat-form-field fxFlex="50">
          <mat-label>Razão Social</mat-label>
          <input
            [readonly]="!hasAccessToEditCompany() || useDataQuality()"
            matInput
            placeholder="Razão Social"
            formControlName="corporateName"
            style="text-overflow: ellipsis"
            required />
          <mat-icon class="icon-lock" *ngIf="!hasAccessToEditCompany() || useDataQuality()" matSuffix alt="ícone de um cadeado">lock</mat-icon>
        </mat-form-field>

        <mat-form-field fxFlex="50">
          <mat-label>Nome Fantasia</mat-label>
          <input
            [readonly]="!hasAccessToEditCompany() || useDataQuality()"
            matInput
            placeholder="Nome Fantasia"
            formControlName="tradingName"
            style="text-overflow: ellipsis" />
          <mat-icon class="icon-lock" *ngIf="!hasAccessToEditCompany() || useDataQuality()" matSuffix alt="ícone de um cadeado">lock</mat-icon>
        </mat-form-field>
      </div>

      <div fxFlex="100">
        <mat-form-field [style.pointer-events]="hasAccessToEditCompany() ? '' : 'none'" fxFlex="13">
          <mat-label>Tipo de Empresa</mat-label>
          <mat-select placeholder="Tipo de Empresa" formControlName="companyType" required>
            <mat-option [value]="0">Matriz</mat-option>
            <mat-option [value]="1">Filial</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field fxFlex>
          <mat-label>Unidade</mat-label>
          <input matInput placeholder="Unidade" formControlName="unit" [readonly]="!hasAccessToEditCompany()" required />
        </mat-form-field>

        <mat-form-field fxFlex="22">
          <mat-label>CNPJ da Unidade</mat-label>
          <input
            [readonly]="!hasAccessToEditCompany() || useDataQuality()"
            matInput
            placeholder="CNPJ da Unidade"
            formControlName="fiscalNumber"
            [textMask]="{
              mask: fiscalNumberMask,
              guide: false,
              keepCharPositions: true
            }"
            required />
          <mat-icon class="icon-lock" *ngIf="!hasAccessToEditCompany() || useDataQuality()" matSuffix alt="ícone de um cadeado">lock</mat-icon>
        </mat-form-field>

        <mat-form-field fxFlex="10">
          <mat-label>N° de Vidas</mat-label>
          <input matInput placeholder="N° de Vidas" required formControlName="employeeCount" [readonly]="!hasAccessToEditCompany()" />
        </mat-form-field>
      </div>

      <div fxFlex="100">
        <mat-form-field fxFlex="20">
          <mat-label>CNPJ da Matriz</mat-label>
          <input
            matInput
            placeholder="CNPJ da Matriz"
            formControlName="headOfficeFiscalNumber"
            [textMask]="{
              mask: fiscalNumberMask,
              guide: false,
              keepCharPositions: true
            }"
            [readonly]="!hasAccessToEditCompany()"
            required />
        </mat-form-field>

        <mat-form-field fxFlex="40">
          <mat-label>Inscrição Estadual</mat-label>
          <input matInput placeholder="Inscrição Estadual" formControlName="stateRegistration" [readonly]="!hasAccessToEditCompany()" />
        </mat-form-field>
        <mat-form-field fxFlex="40">
          <mat-label>Inscrição Municipal</mat-label>
          <input matInput placeholder="Inscrição Municipal" formControlName="municipalRegistration" [readonly]="!hasAccessToEditCompany()" />
        </mat-form-field>
      </div>

      <div fxFlex="100">
        <mat-form-field fxFlex>
          <mat-label>Endereço</mat-label>
          <input
            class="address-field"
            [readonly]="!hasAccessToEditCompany() || useDataQuality()"
            matInput
            placeholder="Endereço"
            formControlName="street"
            style="text-overflow: ellipsis"
            required />
          <mat-icon class="icon-lock" *ngIf="!hasAccessToEditCompany() || useDataQuality()" matSuffix alt="ícone de um cadeado">lock</mat-icon>
        </mat-form-field>

        <mat-form-field fxFlex="15">
          <mat-label>Número</mat-label>
          <input
            class="number-field"
            [readonly]="!hasAccessToEditCompany() || useDataQuality()"
            matInput
            placeholder="Número"
            formControlName="number"
            required />
          <mat-icon class="icon-lock" *ngIf="!hasAccessToEditCompany() || useDataQuality()" matSuffix alt="ícone de um cadeado">lock</mat-icon>
        </mat-form-field>

        <mat-form-field fxFlex="20">
          <mat-label>Complemento</mat-label>
          <input [readonly]="!hasAccessToEditCompany() || useDataQuality()" matInput placeholder="Complemento" formControlName="complement" />
          <mat-icon class="icon-lock" *ngIf="!hasAccessToEditCompany() || useDataQuality()" matSuffix alt="ícone de um cadeado">lock</mat-icon>
        </mat-form-field>
      </div>

      <div fxFlex="100">
        <mat-form-field fxFlex="30">
          <mat-label>Bairro</mat-label>
          <input [readonly]="!hasAccessToEditCompany() || useDataQuality()" matInput placeholder="Bairro" formControlName="district" required />
          <mat-icon class="icon-lock" *ngIf="!hasAccessToEditCompany() || useDataQuality()" matSuffix alt="ícone de um cadeado">lock</mat-icon>
        </mat-form-field>

        <mat-form-field fxFlex="30">
          <mat-label>Cidade</mat-label>
          <input [readonly]="!hasAccessToEditCompany() || useDataQuality()" matInput placeholder="Cidade" formControlName="city" required />
          <mat-icon class="icon-lock" *ngIf="!hasAccessToEditCompany() || useDataQuality()" matSuffix alt="ícone de um cadeado">lock</mat-icon>
        </mat-form-field>

        <mat-form-field fxFlex="15">
          <mat-label>UF</mat-label>
          <input [readonly]="!hasAccessToEditCompany() || useDataQuality()" matInput placeholder="UF" formControlName="region" required />
          <mat-icon class="icon-lock" *ngIf="!hasAccessToEditCompany() || useDataQuality()" matSuffix alt="ícone de um cadeado">lock</mat-icon>
        </mat-form-field>

        <mat-form-field fxFlex="25">
          <mat-label>CEP</mat-label>
          <input
            [readonly]="!hasAccessToEditCompany() || useDataQuality()"
            matInput
            placeholder="CEP"
            formControlName="zipCode"
            [textMask]="{
              mask: zipCodeMask,
              guide: false,
              keepCharPositions: true
            }"
            required />
          <mat-icon class="icon-lock" *ngIf="!hasAccessToEditCompany() || useDataQuality()" matSuffix alt="ícone de um cadeado">lock</mat-icon>
        </mat-form-field>
      </div>
    </form>
    <div class="actions-container">
      <button mat-flat-button class="back-btn" (click)="backToSearchCompanies()">
        <mat-icon aria-hidden="false">arrow_back</mat-icon>
        VOLTAR
      </button>
      <button mat-flat-button *ngIf="hasAccessToEditCompany()" (click)="submitCompanyData()" class="submit-btn">
        <mat-icon aria-hidden="false">save</mat-icon>Salvar
      </button>
    </div>
  </mat-tab>

  <mat-tab label="LISTA DE CONTATOS">
    <div class="contact-control">
      <p class="title">Contatos Cadastrados: {{ getCompanyContacts()?.length }}</p>

      <div *ngIf="hasAccessToEditCompany()" (click)="openContactRegistration()" class="contact-registration-btn">
        <span>REGISTRAR CONTATO</span>
      </div>
    </div>
    <div class="contant-content" fxFlex fxLayout="column">
      <div *ngFor="let contact of getCompanyContacts()" class="contact-card">
        <div class="contact-data" fxFlex="80" fxLayout="column">
          <span class="contact-name">{{ contact.getName() }}</span>
          <div fxFlex>
            <div fxFlex="33">
              <div class="contact-info" [matTooltip]="contact.getUnit() ? contact.getUnit() : ''">
                Unidade:<b>{{ contact.getUnit() ? contact.getUnit() : "-" }}</b>
              </div>
              <div class="contact-info" [matTooltip]="contact.getJobDescription() ? contact.getJobDescription().getTitle() : ''">
                Cargo:<b>{{ contact.getJobDescription() ? contact.getJobDescription().getTitle() : "-" }}</b>
              </div>
              <div class="contact-info" [matTooltip]="contact.getArea() ? contact.getArea() : ''">
                Área:<b>{{ contact.getArea() ? contact.getArea() : "-" }}</b>
              </div>
            </div>

            <div fxFlex="33">
              <div class="contact-info" [matTooltip]="contact.getTelephone() ? (contact.getTelephone() | mobileFormatPipe:false) : ''">
                Telefone:<b>{{ contact.getTelephone() ? (contact.getTelephone()| mobileFormatPipe:false) : "-" }}</b>
              </div>
              <div class="contact-info" [matTooltip]="contact.getMobile() ? (contact.getMobile()| mobileFormatPipe) : ''">
                Celular:<b>{{ contact.getMobile() ? (contact.getMobile()| mobileFormatPipe) : "-" }}</b>
              </div>
              <div class="contact-info" [matTooltip]="contact.getEmail() ? contact.getEmail() : ''">
                E-mail:<b>{{ contact.getEmail() ? contact.getEmail() : "-" }}</b>
              </div>
            </div>

            <div fxFlex="33">
              <div class="contact-info" [matTooltip]="contact.getHasLegalRepresentativeInfo() === true ? 'Sim' : 'Não'">
                Resp. Legal:<b>{{ contact.getHasLegalRepresentativeInfo() === true ? "Sim" : "Não" }}</b>
              </div>
              <div class="contact-info" [matTooltip]="contact.getFederalRegistration() ? (contact.getFederalRegistration() | registroGeralPipe) : ''">
                RG:<b>{{ contact.getFederalRegistration() ? (contact.getFederalRegistration() | registroGeralPipe) : "-" }}</b>
              </div>
              <div class="contact-info" [matTooltip]="contact.getSocialNumber() ? (contact.getSocialNumber() | socialNumberFormatPipe) : ''">
                CPF:<b>{{ contact.getSocialNumber() ? (contact.getSocialNumber() | socialNumberFormatPipe) : "-" }}</b>
              </div>
            </div>
          </div>
        </div>
        <div class="btn-container" fxFlex="20">
          <div class="btn btn-edit" (click)="openContactEdit(contact)">
            <mat-icon class="btn-img" aria-hidden="false">edit_note</mat-icon>
            <span class="btn-title">{{ hasAccessToEditCompany() ? "EDITAR" : "VISUALIZAR" }}</span>
          </div>

          <div class="btn btn-delete" *ngIf="hasAccessToEditCompany()" (click)="openDeleteContactModal(contact)">
            <mat-icon class="btn-img" aria-hidden="false">delete</mat-icon>
            <span class="btn-title">DELETAR</span>
          </div>
        </div>
      </div>
    </div>
  </mat-tab>
  <mat-tab label="LIMITE TRANSACIONAL">
    <div>
      <form [formGroup]="formCompanyConfiguration" (ngSubmit)="submitCompanyConfigurationData()">
        <mat-radio-group [(ngModel)]="companyHasLimit" [ngModelOptions]="{ standalone: true }" class="radio-group">
          <mat-radio-button class="radio-button" name="HasTransactionalLimit" [value]="false" checked="true">
            {{ "Sem Limite" | uppercase }}
          </mat-radio-button>

          <mat-radio-button class="radio-button" name="hasLimit" [value]="true">
            {{ "Limite para próximo ciclo:" | uppercase }}
            <mat-form-field *ngIf="companyHasLimit == true">
              <mat-label>Limite</mat-label>
              <span matPrefix style="color: #3f51b5"> &nbsp; R$ &nbsp;</span>
              <input
                matInput
                id="transactionalLimit"
                formControlName="transactionalLimit"
                type="number"
                required
                min="0.00"
                step="0.01"
                placeholder="Limite"
                pattern="^\d*(\.\d{0,2})?$" />
            </mat-form-field>
          </mat-radio-button>
        </mat-radio-group>
      </form>

      <div class="balance-information" *ngIf="companyHasLimit == true">
        SALDO DISPONÍVEL:
        <div class="mat-form-field mat-form-field-border">
          <span matPrefix style="color: #3f51b5"> &nbsp;</span>
          <span style="color: #252525"> {{ companyRemainingLimit.getRemainingLimitValue() | currencyPbmPipe }} </span>
        </div>
      </div>
      <!-- <div class="current-limit">
        LIMITE VIGENTE
        <div class="mat-form-field mat-form-field-border">
          <span matPrefix style="color: #3f51b5"> &nbsp; R$ &nbsp;</span>
          <span style="color: #252525"></span>
        </div>
      </div> -->
      <div class="actions-container">
        <button mat-flat-button *ngIf="hasAccessToEditCompany()" (click)="submitCompanyConfigurationData()" class="submit-btn">
          <mat-icon aria-hidden="false">save</mat-icon>SALVAR
        </button>
      </div>
    </div>
  </mat-tab>
</mat-tab-group>
